import React, { useState } from 'react';
import * as styles from './carouselMiniatures.module.scss';
import { Swiper as SwiperType } from 'swiper/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { HeroCarouselType } from '../heroCarouselHeader/HeroCarouselHeader';
import ReactPlayer from 'react-player';
import { VideoPlayer } from '../videoPlayer/VideoPlayer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';

interface ICarouselMiniaturesProps {
  items: HeroCarouselType[];
}

export const CarouselMiniatures = ({ items }: ICarouselMiniaturesProps) => {
  const [currentImg, setCurrentImg] = useState(items[0]);
  const [images, setImages] = useState<HeroCarouselType[]>(items);
  const [swiper, setSwiper] = useState<SwiperType>();
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClickImg = (item: HeroCarouselType) => {
    setCurrentImg(item);
    setActiveIndex(0);

    const tmp = [...images];

    while (tmp[0] !== item) {
      const popped = tmp.pop();
      if (popped) tmp.unshift(popped);
    }

    setImages(tmp);
    if (document) {
      document.getElementById('minis')?.scrollTo({ left: 0, behavior: 'smooth' });
    }
  };

  const handleSwipe = (e) => {
    setActiveIndex(e.activeIndex);
    setCurrentImg(items[e.activeIndex]);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.imgDesktop}>
        {!currentImg?.url?.includes('mp4') ? (
          <img
            className={styles.heroImg}
            key={currentImg?._key}
            alt={currentImg?.alt ?? ''}
            src={currentImg?.url ?? ''}
          />
        ) : (
          <div className={styles.heroImg}>
            <VideoPlayer video={currentImg.url ?? ''} />
          </div>
        )}
      </div>
      <div className={styles.swiperWrapper}>
        <Swiper
          className={styles.swiper}
          onSwiper={(e) => setSwiper(e)}
          slidesPerView={1}
          onSlideChange={handleSwipe}
        >
          {images.map((image, i) => (
            <SwiperSlide key={image?._key} onClick={() => handleClickImg(image)}>
              {!image?.url?.includes('mp4') ? (
                <img className={styles.heroImg} alt={image?.alt ?? ''} src={image?.url ?? ''} />
              ) : (
                <div className={styles.heroImg}>
                  <VideoPlayer video={image.url ?? ''} />
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={styles.pagination}>{`${activeIndex + 1}/${items.length}`}</div>
      </div>
      <div id="minis" className={styles.miniatures}>
        {images.map((image) => (
          <div
            key={`${image?._key}-mini`}
            className={styles.imageWrapper}
            onClick={() => handleClickImg(image)}
          >
            {!image?.url?.includes('mp4') ? (
              <img
                className={`${styles.miniImg} ${
                  currentImg._key === image?._key ? styles.selected : ''
                }`}
                key={image?._key}
                alt={image?.alt ?? ''}
                src={image?.url ?? ''}
              />
            ) : (
              <VideoPlaceholder />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const VideoPlaceholder = () => (
  <div className={styles.videoPlaceholder}>
    <FontAwesomeIcon icon={faPlay} color="#F2604D" size="1x" />
  </div>
);
